import React from "react";
import { Box } from "@mui/material";
import useTranslation from "../../../../shared/hooks/useTranslation";
import { dt } from "../../../../shared/themes/redesignTokens";

// ===================================================================
//  DESIGN TOKENS
// ===================================================================


// Priority legend items: color, label key, whether it pulses
const LEGEND_ITEMS: { color: string; labelKey: string; pulse: boolean }[] = [
  { color: "#E74C3C", labelKey: "mapLegendUrgent", pulse: true },
  { color: "#E67E22", labelKey: "mapLegendHigh", pulse: true },
  { color: dt.blueHover, labelKey: "mapLegendMedium", pulse: false },
  { color: "#27AE60", labelKey: "mapLegendLow", pulse: false },
];

// ===================================================================
//  COMPONENT
// ===================================================================

const MapLegend: React.FC = () => {
  const { translate } = useTranslation(["serviceBoard"]);

  return (
    <Box
      sx={{
        position: "absolute",
        bottom: 16,
        left: 16,
        backgroundColor: "rgba(255,255,255,0.92)",
        backdropFilter: "blur(6px)",
        borderRadius: dt.radiusSm,
        padding: "10px 14px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        zIndex: 5,
      }}
    >
      {LEGEND_ITEMS.map((item) => (
        <Box key={item.labelKey} sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Box
            sx={{
              position: "relative",
              width: 14,
              height: 14,
              flexShrink: 0,
            }}
          >
            <Box
              sx={{
                width: 14,
                height: 14,
                borderRadius: "50%",
                backgroundColor: item.color,
              }}
            />
            {item.pulse && (
              <Box
                sx={{
                  position: "absolute",
                  top: -2,
                  left: -2,
                  width: 18,
                  height: 18,
                  borderRadius: "50%",
                  border: `1.5px solid ${item.color}`,
                  animation: "markerPulse 2.5s ease-in-out infinite",
                }}
              />
            )}
          </Box>
          <Box
            sx={{
              fontSize: "12px",
              fontWeight: 500,
              fontFamily: dt.font,
              color: dt.textPrimary,
              whiteSpace: "nowrap",
            }}
          >
            {translate(item.labelKey)}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default React.memo(MapLegend);
